import React from 'react'
import LoginLayout from '../../components/Login/LoginLayout'
import LoginForm from '../../components/Login/LoginForm'
import './Login-container.scss'
import login_logo from './login-logo.svg'   

const Login: React.FC = (props) => {
    return (
        <div className="login">
            <div className="login-bg log-bg" ></div>
            <div className="d-flex flex-row">
                <LoginLayout   {...props} > 
                    <LoginForm {...props}/>
                    {/* <FrogotPass /> */}
                    {/* <ResetPass /> */}
                    {/* <EmailSent email={'jhon@email.com'} {...props} /> */}
                    {/* <ResetSuccess {...props}/> */}
                </LoginLayout>
                <div className="d-flex flex-fill login-logo">
                    <img alt="logo" src={login_logo} />
                </div>
            </div>
        </div>
    );
}


export default Login;
